(() => {
  const $modal = document.querySelector(".modal");

  if(!$modal) {
    return;
  }

  document.addEventListener("click", (e) => {
    if(!$modal.classList.contains("modal--active")) {
      return;
    }

    let $clickedElement = e.target;

    if($clickedElement && !$clickedElement.closest(".modal__container") && !$clickedElement.closest(".w-big-play-button")) {
      $modal.classList.remove("modal--active");
    }
  });

  document.addEventListener("keydown", function(e) {
    if(!$modal.classList.contains("modal--active")) {
      return;
    }

    $modal.classList.remove("modal--active");
  });
})();
